// import { mapState } from 'vuex';

export default {
  /*
    businessContractUnitPrice  合同单价
    productQuantity  合同数量
    businessContractUnitPriceLocal  合同单价-本币
    businessChangeUnitPriceLocal  变动单价-本币
    businessChangeUnitPrice  变动单价
    businessContractTotalAmount  价税合计金额 = 单价*数量
    businessChangeTotalAmount  变动价税合计金额 = 变动单价*数量 //有定价记录时：//变动价格_价税合计金额(业务)=已定价总金额 +变动价格*（商品数量-已定价数量）
    businessContractPureAmount  净值 = 价税合计金额/(1+税率)
    businessChangePureAmount  变动净值 = 变动价税合计金额/(1+税率)
    businessContractTaxAmount  税额 = 价税合计金额-净值（避免尾差）
    businessChangeTaxAmount  变动税额 = 变动价税合计金额-变动净值（避免尾差）
    businessContractTotalAmount  合同价格_价税合计金额(业务)
    businessContractTotalAmountLocal  //（businessContractTotalAmount*rate）
    businessContractTaxAmount  合同价格_税额(业务)
    businessContractTaxAmountLocal  //(businessContractTaxAmount*rate)
    businessContractPureAmount  //合同价格_净值(业务)
    businessContractPureAmountLocal  //(businessContractPureAmount*rate)
    businessChangeTotalAmount  //变动价格_价税合计金额(业务)
    businessChangeTotalAmountLocal  //(businessChangeTotalAmount*rate)
    businessChangeTaxAmount  //变动价格_税额(业务)
    businessChangeTaxAmountLocal  //(businessChangeTaxAmount*rate)
    businessChangePureAmount  //变动价格_净值(业务)
    businessChangePureAmountLocal  //(businessChangePureAmount*rate)
    //主表
    businessContractTotalAmountTotal  // 合同价格_价税合计金额(业务)   计算累计临时存放
    businessContractTaxAmountTotal  合同价格_税额(业务)
    businessContractPureAmountTotal  合同价格_净值(业务)
    businessChangeTotalAmountTotal  变动价格_价税合计金额(业务)
    businessChangeTaxAmountTotal  变动价格_税额(业务)
    businessChangePureAmountTotal  变动价格_净值(业务)
    productQuantityTotal  商品数量
    contractTotalAmount 合同总金额（元）businessContractTotalAmount
    businessContractTotalAmountLocal 合同价格_价税合计金额(业务)  本币 businessContractTotalAmountTotal*rate
    businessContractTaxAmount  合同价格_税额(业务) businessContractTaxAmountTotal
    businessContractTaxAmountLocal // 合同价格_税额(业务)   本币 businessContractTaxAmountTotal*rate
    businessContractPureAmount  // 合同价格_净值(业务)  businessContractPureAmountTotal
    businessContractPureAmountLocal // 合同价格_净值(业务)   本币  businessContractPureAmountTotal*rate
    businessChangeTotalAmount  // 变动价格_价税合计金额(业务)   businessChangeTotalAmountTotal
    businessChangeTotalAmountLocal  // 变动价格_价税合计金额(业务)本币   businessChangeTotalAmountTotal*rate
    businessChangeTaxAmount  // 变动价格_税额(业务)   businessChangeTaxAmountTotal
    businessChangeTaxAmountLocal // 变动价格_税额(业务)本币   businessChangeTaxAmountTotal*rate
    setBusinessChangePureAmount  // 变动价格_净值(业务)   businessChangePureAmountTotal
    setBusinessChangePureAmountLocal   // 变动价格_净值(业务)本币    businessChangePureAmountTotal*rate

   */
  methods: {
    calcMoney: function (row, field, value, rate) {
      // console.log(row, field, value, rate, '混入中接收到的数据');
      // console.log(JSON.stringify(row));
      // console.log(row.isFixedPrice);
      //只有定价才会计算变动价格
      if (row.isFixedPrice == 1) {
        row.businessChangeUnitPrice = row.businessContractUnitPrice;
        row.businessChangeUnitPriceLocal = this.$cal.calCommon(
          row.businessChangeUnitPrice,
          rate,
          '*',
          'price'
        );
      }

      if (field == 'product' || field == 'taxCode') {
        //带出taxCode 计算
        row.businessContractUnitPriceLocal = this.$cal.calCommon(
          row.businessContractUnitPrice,
          rate,
          '*',
          'price'
        );
        row.businessContractTotalAmount = this.$cal.calCommon(
          row.businessContractUnitPrice,
          row.productQuantity,
          '*',
          'amount'
        );
        row.businessContractPureAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          this.$cal.calCommon(row.taxRate, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.businessContractTaxAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          row.businessContractPureAmount,
          '-',
          'amount'
        );
        row.businessContractTotalAmountLocal = this.$cal.calCommon(
          row.businessContractTotalAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractTaxAmountLocal = this.$cal.calCommon(
          row.businessContractTaxAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractPureAmountLocal = this.$cal.calCommon(
          row.businessContractPureAmount,
          rate,
          '*',
          'amount'
        );
      } else if (field == 'businessContractUnitPrice') {
        //合同单价
        row.businessContractUnitPriceLocal = this.$cal.calCommon(
          row.businessContractUnitPrice,
          rate,
          '*',
          'price'
        );
        console.log(row.businessContractTotalAmount, row.businessContractPureAmount, '---1--->>');
        row.businessContractTotalAmount = this.$cal.calCommon(
          row.businessContractUnitPrice,
          row.productQuantity,
          '*',
          'amount'
        );
        console.log(row.businessContractTotalAmount, row.businessContractPureAmount, '--2---->>');
        row.businessContractPureAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          this.$cal.calCommon(row.taxRate, 1, '+', 'amount'),
          '/',
          'amount'
        );
        console.log(row.businessContractTotalAmount, row.businessContractPureAmount, '---3--->>');
        row.businessContractTaxAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          row.businessContractPureAmount,
          '-',
          'amount'
        );
        console.log(row.businessContractTotalAmount, row.businessContractPureAmount, '-----4->>');
        console.log(row.businessContractTaxAmount, '==计算的=???');
        row.businessContractTotalAmountLocal = this.$cal.calCommon(
          row.businessContractTotalAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractTaxAmountLocal = this.$cal.calCommon(
          row.businessContractTaxAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractPureAmountLocal = this.$cal.calCommon(
          row.businessContractPureAmount,
          rate,
          '*',
          'amount'
        );
      } else if (field == 'productQuantity') {
        //销售或采购数量
        row.businessContractUnitPriceLocal = this.$cal.calCommon(
          row.businessContractUnitPrice,
          rate,
          '*',
          'price'
        );
        row.businessContractTotalAmount = this.$cal.calCommon(
          row.businessContractUnitPrice,
          row.productQuantity,
          '*',
          'amount'
        );
        row.businessContractPureAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          this.$cal.calCommon(row.taxRate, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.businessContractTaxAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          row.businessContractPureAmount,
          '-',
          'amount'
        );
        row.businessContractTotalAmountLocal = this.$cal.calCommon(
          row.businessContractTotalAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractTaxAmountLocal = this.$cal.calCommon(
          row.businessContractTaxAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractPureAmountLocal = this.$cal.calCommon(
          row.businessContractPureAmount,
          rate,
          '*',
          'amount'
        );
      } else if (field == 'businessContractTotalAmount') {
        //价税合计金额
        row.businessContractUnitPrice = this.$cal.calCommon(
          value,
          row.productQuantity == 0 ? 1 : row.productQuantity,
          '/',
          'price'
        );
        row.businessContractUnitPriceLocal = this.$cal.calCommon(
          row.businessContractUnitPrice,
          rate,
          '*',
          'price'
        );
        row.businessChangeUnitPriceLocal = this.$cal.calCommon(
          row.businessChangeUnitPrice,
          rate,
          '*',
          'price'
        );
        row.businessContractPureAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          this.$cal.calCommon(row.taxRate, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.businessContractTaxAmount = this.$cal.calCommon(
          row.businessContractTotalAmount,
          row.businessContractPureAmount,
          '-',
          'amount'
        );
        row.businessContractTotalAmountLocal = this.$cal.calCommon(
          row.businessContractTotalAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractTaxAmountLocal = this.$cal.calCommon(
          row.businessContractTaxAmount,
          rate,
          '*',
          'amount'
        );
        row.businessContractPureAmountLocal = this.$cal.calCommon(
          row.businessContractPureAmount,
          rate,
          '*',
          'amount'
        );
      }
      //只有定价才会计算变动价格
      if (row.isFixedPrice == 1) {
        row.businessChangeTotalAmount = this.$cal.calCommon(
          row.businessContractUnitPrice,
          row.productQuantity,
          '*',
          'amount'
        );
        row.businessChangeTotalAmountLocal = this.$cal.calCommon(
          row.businessChangeTotalAmount,
          rate,
          '*',
          'amount'
        );
        row.businessChangePureAmount = this.$cal.calCommon(
          row.businessChangeTotalAmount,
          this.$cal.calCommon(row.taxRate, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.businessChangePureAmountLocal = this.$cal.calCommon(
          row.businessChangePureAmount,
          rate,
          '*',
          'amount'
        );
        row.businessChangeTaxAmount = this.$cal.calCommon(
          row.businessChangeTotalAmount,
          row.businessChangePureAmount,
          '-',
          'amount'
        );
        row.businessChangeTaxAmountLocal = this.$cal.calCommon(
          row.businessChangeTaxAmount,
          rate,
          '*',
          'amount'
        );
      }
    },
    calcMoneyTrade: function (row, field, ratePurchase, rateProxy) {
      if (
        field == 'productDesc' ||
        field == 'contractQuantity' ||
        field == 'purchaseBusinessUnitPrice' ||
        field == 'proxyBusinessUnitPrice'
      ) {
        //带出taxCode 计算
        row.purchaseBusinessUnitPriceLocal = this.$cal.calCommon(
          row.purchaseBusinessUnitPrice,
          ratePurchase,
          '*',
          'price'
        );
        row.proxyBusinessUnitPriceLocal = this.$cal.calCommon(
          row.proxyBusinessUnitPrice,
          rateProxy,
          '*',
          'price'
        );
        row.purchaseBusinessTotalAmount = this.$cal.calCommon(
          row.purchaseBusinessUnitPrice,
          row.contractQuantity,
          '*',
          'amount'
        );
        row.purchaseBusinessPureAmount = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          this.$cal.calCommon(row.taxRatePurchase, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.purchaseBusinessTaxAmount = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          row.purchaseBusinessPureAmount,
          '-',
          'amount'
        );
        row.purchaseBusinessTotalAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          ratePurchase,
          '*',
          'amount'
        );
        row.purchaseBusinessTaxAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessTaxAmount,
          ratePurchase,
          '*',
          'amount'
        );
        row.purchaseBusinessPureAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessPureAmount,
          ratePurchase,
          '*',
          'amount'
        );

        row.proxyBusinessTotalAmount = this.$cal.calCommon(
          row.proxyBusinessUnitPrice,
          row.contractQuantity,
          '*',
          'amount'
        );
        row.proxyBusinessPureAmount = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          this.$cal.calCommon(row.taxRateProxy, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.proxyBusinessTaxAmount = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          row.proxyBusinessPureAmount,
          '-',
          'amount'
        );
        row.proxyBusinessTotalAmountLocal = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          rateProxy,
          '*',
          'amount'
        );
        row.proxyBusinessTaxAmountLocal = this.$cal.calCommon(
          row.proxyBusinessTaxAmount,
          rateProxy,
          '*',
          'amount'
        );
        row.proxyBusinessPureAmountLocal = this.$cal.calCommon(
          row.proxyBusinessPureAmount,
          rateProxy,
          '*',
          'amount'
        );
      } else if (field == 'purchaseBusinessTotalAmount') {
        row.purchaseBusinessUnitPrice = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          row.contractQuantity == 0 ? 1 : row.contractQuantity,
          '/',
          'price'
        );
        row.purchaseBusinessUnitPriceLocal = this.$cal.calCommon(
          row.purchaseBusinessUnitPrice,
          ratePurchase,
          '*',
          'price'
        );
        row.purchaseBusinessUnitPriceLocal = this.$cal.calCommon(
          row.purchaseBusinessUnitPrice,
          ratePurchase,
          '*',
          'price'
        );
        row.purchaseBusinessPureAmount = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          this.$cal.calCommon(row.taxRatePurchase, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.purchaseBusinessTaxAmount = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          row.purchaseBusinessPureAmount,
          '-',
          'amount'
        );
        row.purchaseBusinessTotalAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          ratePurchase,
          '*',
          'amount'
        );
        row.purchaseBusinessTaxAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessTaxAmount,
          ratePurchase,
          '*',
          'amount'
        );
        row.purchaseBusinessPureAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessPureAmount,
          ratePurchase,
          '*',
          'amount'
        );

        row.proxyBusinessTotalAmount = this.$cal.calCommon(
          row.proxyBusinessUnitPrice,
          row.contractQuantity,
          '*',
          'amount'
        );
        row.proxyBusinessPureAmount = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          this.$cal.calCommon(row.taxRateProxy, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.proxyBusinessTaxAmount = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          row.proxyBusinessPureAmount,
          '-',
          'amount'
        );
        row.proxyBusinessTotalAmountLocal = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          rateProxy,
          '*',
          'amount'
        );
        row.proxyBusinessTaxAmountLocal = this.$cal.calCommon(
          row.proxyBusinessTaxAmount,
          rateProxy,
          '*',
          'amount'
        );
        row.proxyBusinessPureAmountLocal = this.$cal.calCommon(
          row.proxyBusinessPureAmount,
          rateProxy,
          '*',
          'amount'
        );
      } else if (field == 'proxyBusinessTotalAmount') {
        row.proxyBusinessUnitPrice = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          row.contractQuantity == 0 ? 1 : row.contractQuantity,
          '/',
          'price'
        );
        row.proxyBusinessUnitPriceLocal = this.$cal.calCommon(
          row.proxyBusinessUnitPrice,
          rateProxy,
          '*',
          'price'
        );
        row.proxyBusinessUnitPriceLocal = this.$cal.calCommon(
          row.proxyBusinessUnitPrice,
          rateProxy,
          '*',
          'price'
        );
        row.purchaseBusinessTotalAmount = this.$cal.calCommon(
          row.purchaseBusinessUnitPrice,
          row.contractQuantity,
          '*',
          'amount'
        );
        row.purchaseBusinessPureAmount = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          this.$cal.calCommon(row.taxRatePurchase, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.purchaseBusinessTaxAmount = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          row.purchaseBusinessPureAmount,
          '-',
          'amount'
        );
        row.purchaseBusinessTotalAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessTotalAmount,
          ratePurchase,
          '*',
          'amount'
        );
        row.purchaseBusinessTaxAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessTaxAmount,
          ratePurchase,
          '*',
          'amount'
        );
        row.purchaseBusinessPureAmountLocal = this.$cal.calCommon(
          row.purchaseBusinessPureAmount,
          ratePurchase,
          '*',
          'amount'
        );

        row.proxyBusinessPureAmount = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          this.$cal.calCommon(row.taxRateProxy, 1, '+', 'amount'),
          '/',
          'amount'
        );
        row.proxyBusinessTaxAmount = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          row.proxyBusinessPureAmount,
          '-',
          'amount'
        );
        row.proxyBusinessTotalAmountLocal = this.$cal.calCommon(
          row.proxyBusinessTotalAmount,
          rateProxy,
          '*',
          'amount'
        );
        row.proxyBusinessTaxAmountLocal = this.$cal.calCommon(
          row.proxyBusinessTaxAmount,
          rateProxy,
          '*',
          'amount'
        );
        row.proxyBusinessPureAmountLocal = this.$cal.calCommon(
          row.proxyBusinessPureAmount,
          rateProxy,
          '*',
          'amount'
        );
      }
    },
  },
};
